import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { ASSETS } from "../lib/data";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Connexa Home", to: "/connexa-home" },
  { label: "Connexa Auto", to: "/connexa-auto" },
  { label: "Come lavoriamo", to: "/#come-lavoriamo" },
  { label: "Chi siamo", to: "/#chi-siamo" },
  { label: "Recensioni", to: "/#recensioni" },
  { label: "Contatti", to: "/#contatti" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-[var(--cx-border)] py-4" : "bg-transparent py-6"
      }`}
    >
      <nav className="cx-container flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src={ASSETS.logo} alt="Connexa" className="h-12 w-auto object-contain md:h-14" />
        </Link>

        <ul className="hidden items-center gap-x-6 xl:flex">
          {NAV.map((n) => (
            <li key={n.label}>
              <Link
                to={n.to}
                data-testid={`nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="link-underline whitespace-nowrap font-body text-[13px] tracking-wide text-[var(--cx-white)]/80 transition-colors hover:text-[var(--cx-white)]"
              >
                {n.label}
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/#contatti"
              data-testid="nav-contact-button"
              className="whitespace-nowrap bg-[var(--cx-gold)] px-6 py-2.5 font-body text-[13px] tracking-wide text-black transition-all duration-300 hover:bg-[var(--cx-gold-bright)]"
            >
              Contattaci
            </Link>
          </li>
        </ul>

        <button
          data-testid="mobile-menu-toggle"
          className="text-[var(--cx-white)] xl:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="mt-4 border-t border-[var(--cx-border)] bg-black/95 backdrop-blur-xl xl:hidden">
          <ul className="cx-container flex flex-col gap-6 py-8">
            {NAV.map((n) => (
              <li key={n.label}>
                <Link
                  to={n.to}
                  data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="font-display text-2xl text-[var(--cx-white)]/90"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};
